var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "div",
          {
            staticClass: "py-1 bg-white",
            class: _vm.isInternetAndMobilePack ? "my-1" : "",
          },
          [
            _c("div", { staticClass: "row" }, [
              _vm.dto.offerDiscountTag
                ? _c("div", { staticClass: "col-12" }, [
                    _c("span", {
                      staticClass: "m-1 ob1-tag ob1-tag-primary",
                      domProps: { innerHTML: _vm._s(_vm.dto.offerDiscountTag) },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "row px-1" }, [
                  _c("div", { staticClass: "col-12 px-0" }, [
                    _vm.dto.isDeviceOutOfStock
                      ? _c(
                          "strong",
                          { staticClass: "ms-1 ob1-tag ob1-tag-unavailable" },
                          [_vm._v("Article non disponible")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row px-1" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 d-flex align-items-md-center",
                          class: _vm.dto.isDeviceOutOfStock
                            ? "unavailable-item"
                            : "",
                        },
                        [
                          _vm.dto.offerDetailsPopinInfo && _vm.dto.visual
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: "#",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target":
                                      "#cart-offer-details-" +
                                      _vm.dto.offerDetailsPopinInfo.idSeo,
                                    "data-test-id":
                                      "btn-popin-detail-offer-image",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.openOffersPopin(
                                        _vm.dto.offerDetailsPopinInfo
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", [
                                    _c("img", {
                                      staticClass: "responsive-img",
                                      attrs: {
                                        alt: _vm.dto.visual.alt,
                                        src: _vm.dto.visual.url,
                                      },
                                    }),
                                  ]),
                                ]
                              )
                            : _vm.dto.offerDetailCta && _vm.dto.visual
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.dto.offerDetailCta.actionUrl,
                                    "data-oevent-category":
                                      _vm.dto.offerDetailCta.tmsData.category,
                                    "data-oevent-action":
                                      _vm.dto.offerDetailCta.tmsData.action,
                                    "data-oevent-label":
                                      _vm.dto.offerDetailCta.tmsData.label,
                                  },
                                },
                                [
                                  _c("div", [
                                    _c("img", {
                                      staticClass: "responsive-img",
                                      attrs: {
                                        alt: _vm.dto.visual.alt,
                                        src: _vm.dto.visual.url,
                                      },
                                    }),
                                  ]),
                                ]
                              )
                            : _vm.dto.visual
                            ? _c("div", [
                                _c("img", {
                                  staticClass: "responsive-img",
                                  attrs: {
                                    alt: _vm.dto.visual.alt,
                                    src: _vm.dto.visual.url,
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "row h-100 w-100 d-flex align-items-center ps-2",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-12 col-md-6 px-0" },
                                [
                                  _vm.dto.offerDetailsPopinInfo
                                    ? _c("ob1-liens", {
                                        staticClass:
                                          "m-0 ob1-link no-decoration",
                                        attrs: {
                                          "is-button": "",
                                          "data-bs-toggle": "modal",
                                          "modal-id":
                                            "cart-offer-details-" +
                                            _vm.dto.offerDetailsPopinInfo.idSeo,
                                          text: _vm.dto.offerName,
                                        },
                                        on: {
                                          "ob1-liens-click": function ($event) {
                                            return _vm.openOffersPopin(
                                              _vm.dto.offerDetailsPopinInfo
                                            )
                                          },
                                        },
                                      })
                                    : _vm.dto.offerDetailCta
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "m-0 ob1-link no-decoration",
                                          attrs: {
                                            href: _vm.dto.offerDetailCta
                                              .actionUrl,
                                            "data-oevent-category":
                                              _vm.dto.offerDetailCta.tmsData
                                                .category,
                                            "data-oevent-action":
                                              _vm.dto.offerDetailCta.tmsData
                                                .action,
                                            "data-oevent-label":
                                              _vm.dto.offerDetailCta.tmsData
                                                .label,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(_vm.dto.offerName) +
                                              "\n                                            "
                                          ),
                                        ]
                                      )
                                    : _c("p", { staticClass: "fw-bold m-0" }, [
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(_vm.dto.offerName) +
                                            "\n                                            "
                                        ),
                                      ]),
                                  _vm._v(" "),
                                  _vm.formattedAddressInfo
                                    ? _c("CartEligibilityInfo", {
                                        staticClass: "d-none d-md-flex",
                                        attrs: {
                                          "formatted-address-info":
                                            _vm.formattedAddressInfo,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-md-6 d-flex justify-content-md-end text-md-end pe-1",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-12 ps-0" },
                                        [
                                          _vm.dto.price
                                            ? _c("Price", {
                                                attrs: {
                                                  price: _vm.dto.price.price,
                                                  "initial-price":
                                                    _vm.dto.price.initialPrice,
                                                  "price-details": _vm.dto.price
                                                    .priceDetails
                                                    ? _vm.dto.price.priceDetails
                                                    : undefined,
                                                  "show-from":
                                                    _vm.dto.price.showFrom,
                                                  "show-by-month":
                                                    _vm.dto.price.showByMonth,
                                                  "show-promo-duration":
                                                    _vm.dto.price
                                                      .showPromoDuration,
                                                  "show-end-of-promotion-price":
                                                    _vm.dto.price
                                                      .showEndOfPromotionPrice,
                                                  "show-children-promotion-price":
                                                    _vm.dto.price
                                                      .showChildrenPromotionPrice,
                                                  "show-promo-duration-first-months":
                                                    _vm.dto.price
                                                      .showPromoDurationFirstMonths,
                                                  duration:
                                                    _vm.dto.price.duration,
                                                  "is-cents-format": false,
                                                  "is-mini": true,
                                                  custom: "text-dark",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.isInternetAndMobilePack
                                        ? _c(
                                            "div",
                                            { staticClass: "col-12 ps-0" },
                                            [
                                              _vm.dto.discountLabel
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-md-end",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "alert-container alert-container-sm additional-message bg-greige",
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "alert",
                                                            },
                                                            [
                                                              _c("span", {
                                                                staticClass:
                                                                  "alert-icon icon-phone-fund-euro text-primary",
                                                                attrs: {
                                                                  "aria-hidden":
                                                                    "true",
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                staticClass:
                                                                  "ob1-alert-title",
                                                                domProps: {
                                                                  textContent:
                                                                    _vm._s(
                                                                      _vm.dto
                                                                        .discountLabel
                                                                    ),
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.formattedAddressInfo
                                        ? _c("CartEligibilityInfo", {
                                            staticClass:
                                              "col-12 d-flex d-md-none ps-0",
                                            attrs: {
                                              "formatted-address-info":
                                                _vm.formattedAddressInfo,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 pt-1 d-flex justify-content-end text-end",
                        },
                        [
                          _c("div", { staticClass: "d-flex" }, [
                            _vm.dto.modifyOfferCta
                              ? _c("div", { staticClass: "pe-1" }, [
                                  _c("a", {
                                    staticClass: "ob1-link py-0",
                                    attrs: {
                                      href: _vm.dto.modifyOfferCta.actionUrl,
                                      "data-oevent-category":
                                        _vm.dto.modifyOfferCta.tmsData.category,
                                      "data-oevent-action":
                                        _vm.dto.modifyOfferCta.tmsData.action,
                                      "data-oevent-label":
                                        _vm.dto.modifyOfferCta.tmsData.label,
                                    },
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.dto.isDeviceOutOfStock
                                          ? "Remplacer ce téléphone"
                                          : _vm.dto.modifyOfferCta.label
                                      ),
                                    },
                                  }),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dto.removeOfferCta
                              ? _c("div", { staticClass: "ps-1" }, [
                                  _c("button", {
                                    staticClass: "ob1-link py-0",
                                    attrs: {
                                      "data-oevent-category":
                                        _vm.dto.removeOfferCta.tmsData.category,
                                      "data-oevent-action":
                                        _vm.dto.removeOfferCta.tmsData.action,
                                      "data-oevent-label":
                                        _vm.dto.removeOfferCta.tmsData.label,
                                    },
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.dto.removeOfferCta.label
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeOfferFromCart($event)
                                      },
                                    },
                                  }),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.dto.offerEquipment
                ? _c("div", { staticClass: "col-12 pt-2" }, [
                    _c("div", { staticClass: "row px-1" }, [
                      _c("div", { staticClass: "col-12 px-0" }, [
                        _c("div", { staticClass: "row px-1" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 d-flex align-items-md-center",
                              class: _vm.dto.isDeviceOutOfStock
                                ? "unavailable-item"
                                : "",
                            },
                            [
                              _vm.dto.offerEquipment.detailCta &&
                              _vm.dto.offerEquipment.visual
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.dto.offerEquipment.detailCta
                                          .actionUrl,
                                        "data-oevent-category":
                                          _vm.dto.offerEquipment.detailCta
                                            .tmsData.category,
                                        "data-oevent-action":
                                          _vm.dto.offerEquipment.detailCta
                                            .tmsData.action,
                                        "data-oevent-label":
                                          _vm.dto.offerEquipment.detailCta
                                            .tmsData.label,
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _c("img", {
                                          staticClass: "responsive-img",
                                          attrs: {
                                            alt: _vm.dto.offerEquipment.visual
                                              .alt,
                                            src: _vm.dto.offerEquipment.visual
                                              .url,
                                          },
                                        }),
                                      ]),
                                    ]
                                  )
                                : _vm.dto.offerEquipment.visual
                                ? _c("div", [
                                    _c("img", {
                                      staticClass: "responsive-img",
                                      attrs: {
                                        alt: _vm.dto.offerEquipment.visual.alt,
                                        src: _vm.dto.offerEquipment.visual.url,
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row h-100 w-100 d-flex align-items-center ps-2",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-6 px-0" },
                                    [
                                      _vm.dto.offerEquipment.detailCta &&
                                      _vm.dto.offerEquipment.detailCta.actionUrl
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "m-0 ob1-link no-decoration",
                                              attrs: {
                                                href: _vm.dto.offerEquipment
                                                  .detailCta.actionUrl,
                                                "data-oevent-category":
                                                  _vm.dto.offerEquipment
                                                    .detailCta.tmsData.category,
                                                "data-oevent-action":
                                                  _vm.dto.offerEquipment
                                                    .detailCta.tmsData.action,
                                                "data-oevent-label":
                                                  _vm.dto.offerEquipment
                                                    .detailCta.tmsData.label,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    _vm.dto.offerEquipment
                                                      .offerName
                                                  ) +
                                                  "\n                                            "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "p",
                                            { staticClass: "fw-bold m-0" },
                                            [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    _vm.dto.offerEquipment
                                                      .offerName
                                                  ) +
                                                  "\n                                            "
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-md-6 d-flex justify-content-md-end text-md-end pe-1",
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 ps-0" },
                                          [
                                            _vm.dto.offerEquipment.price
                                              ? _c("Price", {
                                                  attrs: {
                                                    price:
                                                      _vm.dto.offerEquipment
                                                        .price.price,
                                                    "initial-price":
                                                      _vm.dto.offerEquipment
                                                        .price.initialPrice,
                                                    "price-details": _vm.dto
                                                      .offerEquipment.price
                                                      .priceDetails
                                                      ? _vm.dto.offerEquipment
                                                          .price.priceDetails
                                                      : undefined,
                                                    "show-from":
                                                      _vm.dto.offerEquipment
                                                        .price.showFrom,
                                                    "show-by-month":
                                                      _vm.dto.offerEquipment
                                                        .price.showByMonth,
                                                    "show-promo-duration":
                                                      _vm.dto.offerEquipment
                                                        .price
                                                        .showPromoDuration,
                                                    "show-end-of-promotion-price":
                                                      _vm.dto.offerEquipment
                                                        .price
                                                        .showEndOfPromotionPrice,
                                                    "show-promo-duration-first-months":
                                                      _vm.dto.offerEquipment
                                                        .price
                                                        .showPromoDurationFirstMonths,
                                                    duration:
                                                      _vm.dto.offerEquipment
                                                        .price.duration,
                                                    "is-cents-format": false,
                                                    "is-mini": true,
                                                    custom: "text-dark",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 pt-1 d-flex justify-content-end text-end",
                            },
                            [
                              _c("div", { staticClass: "d-flex" }, [
                                _vm.dto.offerEquipment.modifyCta
                                  ? _c("a", {
                                      staticClass: "ob1-link py-0",
                                      attrs: {
                                        href: _vm.dto.offerEquipment.modifyCta
                                          .actionUrl,
                                        "data-oevent-category":
                                          _vm.dto.offerEquipment.modifyCta
                                            .tmsData.category,
                                        "data-oevent-action":
                                          _vm.dto.offerEquipment.modifyCta
                                            .tmsData.action,
                                        "data-oevent-label":
                                          _vm.dto.offerEquipment.modifyCta
                                            .tmsData.label,
                                      },
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.dto.isDeviceOutOfStock
                                            ? "Remplacer ce téléphone"
                                            : _vm.dto.offerEquipment.modifyCta
                                                .label
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayOdrDiv
                ? _c("div", { staticClass: "col-12 px-2 pt-1" }, [
                    _c(
                      "ul",
                      {
                        staticClass: "row list-unstyled mb-0",
                        attrs: { "aria-label": "Offres de remboursement" },
                      },
                      _vm._l(
                        _vm.dto.odrsHtml,
                        function (odrHtml, odrHtmlIndex) {
                          return _c(
                            "li",
                            { key: "odr-html-without-update-" + odrHtmlIndex },
                            [
                              _c("InlinePromise", {
                                attrs: {
                                  claim: { attributes: { textHtml: odrHtml } },
                                  "is-warning": true,
                                  "compact-text": true,
                                },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.dto.offerDetailsPopinInfo
        ? _c("CartOfferDetailsPopin", {
            attrs: {
              id: "cart-offer-details-" + _vm.dto.offerDetailsPopinInfo.idSeo,
              "cart-offer-details": _vm.dto.offerDetailsPopinInfo,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }